import React from 'react';
import {Chip, useTheme} from '@mui/material';
import {ChipColorEnum, TagChipProps} from './types';
import {tagChipOptions} from './constants';

export function TagChip({
	color = ChipColorEnum.DEFAULT,
	usePrimaryTextColor = true,
	sx,
	variant = 'filled',
	bgColor,
	...props
}: TagChipProps) {
	const theme = useTheme();

	return (
		<Chip
			variant={variant}
			size="small"
			color={color}
			sx={{
				color: usePrimaryTextColor ? 'text.primary' : undefined,
				'& .MuiChip-label': {
					color: usePrimaryTextColor ? 'text.primary' : undefined,
				},
				backgroundColor: bgColor || tagChipOptions(theme, color),
				...sx,
			}}
			{...props}
		/>
	);
}
